import axios from "axios";

class Newsletter {
  constructor(element) {
    if (!element) return;

    this.elements = {
      parent: element,
      form: element.querySelector('form'),
      submit: element.querySelector('button[type="submit"]'),
      email: element.querySelector('input[name="email"]'),
      consent: element.querySelector('input[type="checkbox"][name="consent"]'),
      message: element.querySelector('.js-newsletter-message'),
    }

    this.settings = {
      ajaxURL: newsletter_vars.ajaxUrl,
      wpNonce: newsletter_vars.wpNonce,
      lang: newsletter_vars.lang,
      action: newsletter_vars.action,
      consentMessage: newsletter_vars.consentMessage,
      errorMessage: newsletter_vars.errorMessage,
    }

    this.state = {
      sent: false,
      loading: false,
      error: false,
    }

    this.init();
  }

  setState(newState, refresh = true) {
    this.state = {
      ...this.state,
      ...newState,
    }

    if (refresh) {
      this.update();
    }
  }

  init() {
    const { form } = this.elements;

    if (!form) return;

    this.initFields();

    form.addEventListener('submit', e => {
      e.preventDefault();

      if (!this.state.loading) {
        this.submit();
      }
    });
  }

  initFields() {
    const { consent } = this.elements;

    if (!consent) return;

    consent.addEventListener('change', e => {
      this.setState({ error: !e.target.checked });
    });
  }

  getFormData() {
    const formData = new FormData();
    formData.append('action', this.settings.action);
    formData.append('wpNonce', this.settings.wpNonce);
    formData.append('email', this.elements.email.value);
    formData.append('consent', this.elements.consent.checked);
    formData.append('lang', this.settings.lang);

    return formData;
  }

  async submit() {
    if (!this.elements.consent.checked) {
      this.setState({ error: true });
      this.errorResult(this.settings.consentMessage);
      return;
    }

    this.setState({ loading: true });
    try {
      const response = await axios.post(this.settings.ajaxURL, this.getFormData());

      if (response.status === 200) {
        const data = response.data;

        if (data.code === 200) {
          this.setState({ sent: true });
          this.successResult(data.message);

          if (window.dataLayer) {
            window.dataLayer.push({'event':'newsletter_sign_up'});
          }
        } else {
          this.setState({ error: true });
          this.errorResult(data.message);
        }
      }
      this.setState({ loading: false });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false, error: true });
      this.errorResult(this.settings.errorMessage);
    }
  }

  successResult(message = "") {
    this.reset();
    this.elements.message.innerText = message;
    this.elements.message.classList.remove('hidden');
    this.elements.message.classList.remove('error');
    this.elements.message.classList.add('success');
  }

  errorResult(message = "") {
    this.elements.message.innerText = message;
    this.elements.message.classList.remove('hidden');
    this.elements.message.classList.remove('success');
    this.elements.message.classList.add('error');
  }

  update() {
    const { form } = this.elements;

    if (this.state.loading) {
      form.classList.add('is-loading');
    } else {
      form.classList.remove('is-loading');
    }

    if (this.state.error) {
      form.classList.add('has-error');
    } else {
      form.classList.remove('has-error');
    }

    if (this.state.sent) {
      form.classList.add('was-sent');
    } else {
      form.classList.remove('was-sent');
    }
  }

  reset() {
    this.elements.form.reset();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-newsletter');

  if (elements.length === 0) return;

  elements.forEach(element => {
    new Newsletter(element);
  })
});
